import { MapContainer, Marker, Polyline } from "react-leaflet";
import tokens from "@/theme/tokens";
import { PIN_ICONS } from "@/components/map/pins";
import { DarkTiles, FitView } from "@/components/map/PinMap";

export function RouteMap({ pickup, dropoff }) {
  const points = [pickup, dropoff].filter(Boolean).map((p) => [p.lat, p.lng]);
  return (
    <div className="relative h-56 overflow-hidden rounded-3xl border border-line sm:h-72" data-testid="route-map">
      <MapContainer center={points[0] || tokens.map.center} zoom={13} scrollWheelZoom={false} className="h-full w-full">
        <DarkTiles />
        <FitView points={points} animate={false} />
        {points.length > 1 && (
          <Polyline positions={points} pathOptions={{ color: tokens.colors.gold, weight: 2.5, dashArray: "6 8", opacity: 0.9 }} />
        )}
        <Marker position={[pickup.lat, pickup.lng]} icon={PIN_ICONS.pickup} />
        {dropoff && <Marker position={[dropoff.lat, dropoff.lng]} icon={PIN_ICONS.dropoff} />}
      </MapContainer>
    </div>
  );
}
